// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__FZIDQ","file":"styles_file__3D6ex"};